const MessageTypes = {
  UpdatedSize: 'updatedSize',
} as const;

export default MessageTypes;
